import { Injectable } from '@angular/core';

import { CatalogObject } from '../catalog-object';
import { Layer } from '../layer/layer';
import { Adapter } from './adapter';
import { CatalogObjectAdapterService } from './catalog-object-adapter.service';

@Injectable({
    providedIn: 'root',
})
export class LayerAdapterService extends CatalogObjectAdapterService implements Adapter<Layer> {
    override adapt(item: any): Layer {
        const adaptedCatalog: CatalogObject = super.adapt(item);
        const adaptedLayer: Layer = adaptedCatalog as Layer;

        return adaptedLayer;
    }

    adaptList(response: any): Layer[] {
        return response.results.map((item: Layer) => this.adapt(item));
    }
}
